import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { UserActions, UserRoles } from "../models/Authorisation";
import { PRODUCT_STATUS } from "../models/Product";

export type User = {
  id?: string;
  name?: string;
  email?: string;
  role?: UserRoles;
  isApprover?: boolean;
};

type UserState = {
  user?: User;
  setUser: (user: User) => void;
  userActions: Partial<Record<PRODUCT_STATUS, UserActions[]>> | undefined;
  ppsUserAction: Partial<Record<PRODUCT_STATUS, UserActions[]>> | undefined;
  leadsUserAction: Partial<Record<PRODUCT_STATUS, UserActions[]>> | undefined;
  setUserActions: (
    prodStatusToAction: Partial<Record<PRODUCT_STATUS, UserActions[]>>,
  ) => void;
  setPpsUserAction: (
    prodStatusToAction: Partial<Record<PRODUCT_STATUS, UserActions[]>>,
  ) => void;
  setLeadsUserAction: (actions: Partial<Record<PRODUCT_STATUS, UserActions[]>>,) => void;
  setUserRole: (userRole: UserRoles) => void;
  clearUser: () => void;
  country?: string[];
  setCountry: (country: string[]) => void;
};

export const useUserStore = create(
  persist<UserState>(
    set => ({
      user: undefined,
      setUser: user => {
        set(state => ({
          user: {
            ...state.user,
            ...user,
          },
        }));
      },
      userActions: undefined,
      setUserActions: prodStatusToAction => {
        set({ userActions: prodStatusToAction });
      },
      country: [],
      setCountry: permissionCountry => {
        set({ country: permissionCountry });
      },
      ppsUserAction: undefined,
      setPpsUserAction: ppsUserAction => {
        set({ ppsUserAction: ppsUserAction });
      },
      leadsUserAction: undefined,
      setLeadsUserAction: leadsUserAction => {
        set({ leadsUserAction: leadsUserAction });
      },
      setUserRole: userRole => {
        set(state => ({
          user: {
            ...state.user,
            role: userRole,
            isApprover: userRole === UserRoles.PM,
          },
        }));
      },
      clearUser: () => {
        set({
          user: undefined,
        });
      },
    }),
    {
      name: "userinfo-storage",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
